import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { consumeSseStream } from '@/lib/api';

export const useRetailor = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: async (jobId: number) => {
      const res = await fetch(`/api/jobs/${jobId}/retailor`, {
        method: 'POST',
      });

      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`);
      }

      return consumeSseStream(res, {} as Record<string, unknown>);
    },
    onError: (error: Error) => push(error.message || 'Tailor failed', 'error'),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['job'] });
      const { warnings } = result as { warnings?: string[] };

      if (warnings?.length) {
        push(warnings.join(' '), 'info');
      } else {
        push('Résumé retailored', 'success');
      }
    },
  });
};
